import { useContext, useState } from 'react';
import _noop from 'lodash/noop';

import { ModalContext } from 'commons-ui';
import useService from '../../useService';
import { IUseContentProps } from '../types';

const useContent = (props: IUseContentProps) => {
	const { handleForceUpdate = _noop } = props;
	const { unsetPhone } = useService();
	const { setModalConfig } = useContext(ModalContext);
	const [showLoader, setShowLoader] = useState(false);

	const handleSubmit = async (submittedData: any) => {
		const { behaviour } = submittedData;

		setShowLoader(true);
		await unsetPhone(behaviour);
		handleForceUpdate();
		setModalConfig({ isOpen: false });
		setShowLoader(false);
	};

	const handleCancel = () => {
		setModalConfig({ isOpen: false });
	};

	return {
		handleSubmit,
		handleCancel,
		showLoader,
		setShowLoader
	};
};

export default useContent;
